import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box,
  Radio
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dateFormatter, dropdownFetch, formatDate, getKeyPathValue, getMonthYear, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { PHARMACY_PRODUCT_TYPE } from '../../../../../constants/dropdown';
import axios from 'axios';
import { StockTransferVoucherTable } from '../utils/StockTransferVoucherTable';
import { WarehouseStockTransferRequestDetailForm } from './WarehouseStockTransferRequestDetailForm';

const POS_HEADER = [
  { header: 'Transfer No.', accessor: 'stock_transfer_no'},
  { header: 'Indent No.', accessor: 'indent_no' },
  { header: 'Transfer Date', accessor: (row) => formatDate(row?.createdAt)},
  { header: 'From Location', accessor: (row)=> row?.from_location?.warehouse_name },
  { header: 'To Location', accessor: (row) =>  row?.to_location?.warehouse_name },
];

const INDENT_TABLE_COLUMNS = [
  { header: 'Indent No.', accessor: 'indent_no' },
  {
    header: 'To Organisation',
    accessor: 'to_org'
  },
  {
    header: 'To Location',
    accessor: (row) => row?.to_location?.warehouse_name
  },
  {
    header: 'Req. User',
    accessor: 'createdBy'
  },
  {
    header: 'Date',
    accessor: (row) => formatDate(row?.date)
  }
];

const initialPatientDataObj = {
  data: [],
  loading: false
};
const initialPosDataObj = {
  data: [],
  loading: false
};

const initialStockTransferVoucherObj = {
  data: [],
  loading: false
};
export const StockTransferVoucher = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [stockTransferVoucherObj, setStockTransferVoucherObj] = useState(initialStockTransferVoucherObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [input, setInput] = useState('');
  const [warehouse, setWareHosue] = useState([]);
  const [posData, setPosData] = useState([]);
  const productRef = useRef();
  const [selectedRadio, setSelectedRadio] = useState('today');
  const [selectedRows, setSelectedRows] = useState([]);
  const [warehouseRequest, setWareHouseRequest] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const [productDropdown,setProductDropdown] = useState([])
  const [rows,setRows] = useState([])
  const[addDetailsDialogue,setAddDetailsDialogOpen] = useState(false)
  const [productStock,setProductStock] = useState([])
  const[filteredServiceList,setFilteredServiceList] = useState([])
  const [storeProductDropdown,setStoreProductDropdown] = useState([])
  const [voucherInput,setVoucherInput]  = useState('')
  const [id,setId] = useState("")

  function getMonthYear(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    return `${year}-${month}`;
  }

  const PRODUCT_TABLE_HEADER = [
    { header: 'Req. Product', accessor: (row) => row?.product?.main?.name || row?.store_product?.name  || row?.requested_product_name|| "-" },
    { header: 'Req Qty', accessor: (row) => row?.requested_qty || "-"},
    { header: 'Bill Qty', accessor: (row) => row?.closing_qty ||"-"},
    { header: 'Iss. Product', accessor: (row) => row?.issued_product_name  ||  "-" },
    { header: 'Iss. Qty', accessor: (row) => row?.issued_quantity|| "-"},
    { header: 'Cost Price', accessor: (row) => row?.cost_price || '-' },
    { header: 'MRP', accessor: (row) => row?.mrp || "-" },
    { header: 'Sale Price', accessor: (row) => row?.sale_price || '-' },
    { header: 'Batch No.', accessor: (row) => row?.batch_no || '-' },
    { header: 'Exp. Date', accessor: (row) => getMonthYear(row?.exp_date) || '-' },
    { header: 'Stock In Hand', accessor: (row) => row?.closing_qty ||"-" }
  ];

  useEffect(() => {
    if (selectedRecord) {
      setValue('from_location',selectedRecord?.from_location?.warehouse_name)
      setValue('to_location',selectedRecord?.to_location?.warehouse_name)
      setValue('to_company',selectedRecord?.warehousestocktransferinfo?.to_org)
      setValue('indent_no',selectedRecord?.indent_no)
      setValue('stock_transfer_no',selectedRecord?.stock_transfer_no)
      setValue('remarks',selectedRecord?.remarks)
      setProductDetails(selectedRecord?.productDetails)
    } else {
      reset();
    }
  }, [selectedRecord]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
      indent_no: Yup.string().required(' '),
      })
    ),
    defaultValues: {
      stock_transfer_date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      product_type: 'pharmacy product',
      bill: {
        out_sourced: 'No',
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const formSubmit = async (formValues) => {
    if (selectedRows.length === 0) {
      toast('Please add the Product Data First', { variant: 'warning' });
      return;
    }
    const productData = selectedRows.map((row) => ({
      ...row,
      issued_product: row?.issued_product,
      requested_product : row?.product?._id || row?.requested_product,
      requested_store_product : row?.store_product?._id,
      issued_store_product : row?.issued_store_product,
    }));
    const payload = {
      ...formValues,
      productDetails: productData,
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/stock-transfer-voucher-update' : '/stock-transfer-voucher-create',{
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success && response.data) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Stock Transfer Voucher `, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
      setProductDetails([]);
      setSelectedRows([])
      handleWareHouseSearch()
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Stock Transfer Voucher`, { variant: 'error' });
    }
    setLoading(false);
  };



  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    const response = await request('/stock-transfer-voucher-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setStockTransferVoucherObj({ loading: false, data: filteredData });
      setPosData({ data: response.data });
    } else {
      toast('Failed to load Stock Transfer Voucher', { variant: 'error' });
      setStockTransferVoucherObj({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/retail-sale-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Retail Sale Pos', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Retail Sale Pos', { variant: 'error' });
    }
    setLoading(false);
  };

  const getLocationDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('location', defaultState?._id);
    }
    setWareHosue(data);
  }, []);

  const getStockMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('stock-master');
    const flattenedProductDetails = data.flatMap(item => item.productDetails);
    setProductStock(flattenedProductDetails);
  }, []);

  const getStoreStockMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('store-stock-master');
    setStoreProductDropdown(data);
  }, []);
  
  

  useEffect(() => {
    getLocationDropdown();
    getStockMasterDropdown()
    getStoreStockMasterDropdown()
  }, [getLocationDropdown,getStockMasterDropdown,getStockMasterDropdown]);

  const handleRowClick = (row) => {
    setProductDetails(row?.add_details);
    setValue('indent_no', row?.indent_no);
    setValue('from_location_id',row?.from_location?._id)
    setValue('product_type', row?.product_type);
    setValue('from_location', row?.from_location?.warehouse_name);
    setValue('to_location', row?.to_location?.warehouse_name);
    setValue('to_company', row?.to_org);
    const formattedRegDate = row?.date ? new Date(row.date).toISOString().split('T')[0] : '';
    setValue('stock_transfer_date', formattedRegDate);
  };

  const handleRadioChange = (event) => {
    const { name } = event.target;
    setSelectedRadio(name);
  };

  const watchProductType = watch('product_type');

  useEffect(() => {
    handleWareHouseSearch();
  }, [watchProductType,selectedRadio]);

  const handleWareHouseSearch = async () => {
    try {
      setProductDetails([]);
      const response = await axios.get(
        `${BASE_URL}/warehouse-stock-request/dropdown?limit=${50}&name=${watchProductType}&time=${selectedRadio}`
      );
      if (response.data.success) {
        setWareHouseRequest(response.data.data);
      } else {
        toast('Error in fetching data', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
    }
  };

  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };


  const handleRowSelect = (row, field) => {
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };
  const productTypeWatch  = watch('product_type')
  const onDetailAddHandler = (formValues) => {
    let matchedProduct = productStock.find(
      (item) => item?.product._id.toString() === formValues.issued_product.toString()
    );
    
    if (!matchedProduct) {
      matchedProduct = storeProductDropdown.find(
        (item) => item?.product._id.toString() === formValues.issued_product.toString()
      );
    }
    const productName = matchedProduct?.product?.main?.name || matchedProduct?.product?.name;
    const newMedicineData = {
      issued_product: formValues?.issued_product,
      issued_store_product : formValues.store_product,
      issued_product_name: productName, 
      batch_no : formValues?.batch_no,
      exp_date : formValues?.exp_date,
      mrp : formValues?.mrp,
      cost_price: formValues.cost_price,
      sale_price : formValues.sale_price,
      issued_quantity:  formValues.requested_qty, 
      issued_qty : formValues.closing_qty
    };
    setProductDetails((prevData) => {
      const updatedData = prevData.map((item) =>
        item?.product?._id === formValues?._id  
          ? { ...item, ...newMedicineData, modified: true } 
          : item
      );
      toast('Successfully Updated Product Details', { variant: 'success' });
      return updatedData;
    });
};

  const handleEditClick=(row)=>{
    setId(row?.product?._id)
   setAddDetailsDialogOpen(true)
  }


  useEffect(()=>{
    handleSearch()
  },[voucherInput])

  const handleVoucherChange =(e)=>{
    setVoucherInput(e.target.value)
  }
 
  const handleSearch = async () => {
    const lowercasedInput = voucherInput.toUpperCase().trim();
    const limit = 10;
    try {
      const response = await request('/stock-transfer-voucher-list', {
        method: 'GET',
        query: { name: lowercasedInput, limit: limit }
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setStockTransferVoucherObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setStockTransferVoucherObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setStockTransferVoucherObj({ loading: false, data: [] });
    }
  };


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Stock Transfer Voucher
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.8,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="product_type"
                      menus={PHARMACY_PRODUCT_TYPE}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.6rem' }}>Type</Typography>
                    <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="today"
                      checked={selectedRadio === 'today'}
                      onChange={handleRadioChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Today</Typography>
                    <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="pending"
                      checked={selectedRadio === 'pending'}
                      onChange={handleRadioChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Pending </Typography>
                    <Radio
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{
                        flex: 0.6,
                        border: currentAction ? '0.5px solid red' : '',
                        backgroundColor: currentAction ? '#B3E5FC' : ''
                      }}
                      name="partial"
                      checked={selectedRadio === 'partial'}
                      onChange={handleRadioChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Partial</Typography>
                  </Stack>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '40rem', marginTop: '1%' }}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                      <MuiTextField
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            padding: '0',
                            fontSize: '16px',
                            fontWeight: '700'
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 14px'
                          }
                        }}
                        label="Search Here"
                        variant="outlined"
                        value={input}
                        inputRef={productRef}
                      />
                    </Stack>

                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '40rem' }}
                      data={currentAction === 'new' ? warehouseRequest : []}
                      columns={INDENT_TABLE_COLUMNS}
                      size="small"
                      onRowClick={(row) => {
                        handleRowClick(row);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={8.5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack
                    sx={{ border: '0px solid grey', padding: '5px', borderRadius: '5px' }}
                    spacing={0.5}
                    direction="row"
                  >
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Stock Tranfer No.
                        </Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="stock_transfer_no"
                          placeholder="Stock Trnasfer No."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>From Location</Typography>
                        <TextField
                          disabled
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : '',
                            backgroundColor: currentAction ? '#B3E5FC' : ''
                          }}
                          name="from_location"
                          placeholder="From Location"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Stock Indent No.
                        </Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="indent_no" placeholder="Stock Indent No." />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Product Type</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="product_type" placeholder="Product Type" />
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                    >
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>
                          Stock Transfer Date
                        </Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="stock_transfer_date" type="date" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>To Company</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="to_company" placeholder="To Company" />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>To Location</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="to_location" placeholder="To Location" />
                      </Stack>
                    </Grid>
                  </Stack>
                  <StockTransferVoucherTable
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={productDetails.map((data) => ({ ...data,  _id: data?._id  }))  || []}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    selectedRows={selectedRows}
                    rows={rows}
                    columns={PRODUCT_TABLE_HEADER}
                    size="medium"
                    showOk={true}
                    showInputField={true}
                    editMedicine={true}
                    onClickEdit={handleEditClick}
                  />
                  <Stack direction="row" spacing={0.5} alignItems="center" marginTop={'5%'}>
                    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', flex: 0.4 }}>Remarks</Typography>
                      <TextField
                        sx={{ width: '100%' }}
                        name="remarks"
                        disabled={!['new', 'edit'].includes(currentAction)}
                      />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
           Stock Transfer Voucher Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search Stock Transfer Voucher"
            variant="outlined"
            value={voucherInput}
            onChange={handleVoucherChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={POS_HEADER}
          data={stockTransferVoucherObj?.data || []}
          loading={posData.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        open={addDetailsDialogue}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <WarehouseStockTransferRequestDetailForm
          onClose={() => setAddDetailsDialogOpen(false)}
          productDropdown={productDropdown}
          setFilteredServiceList={setFilteredServiceList}
          filteredServiceList={filteredServiceList}
          productType={productTypeWatch}
          setProductDropdown={setProductDropdown}
          setStoreProductDropdown={setStoreProductDropdown}
          onAdd={onDetailAddHandler}
          rowId={id}
        />
      </Dialog>
    </>
  );
};
